import { defineMessages } from 'react-intl';

export const generalCardTranslations = defineMessages({
  updatedOn: {
    id: 'generalCard.updatedOn',
    defaultMessage: 'Updated on {date} at {time}',
    description: 'General card updatedOn label',
  },
});
